import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import PropTypes from 'prop-types';

const HeroImage = props => {
  return (
    <div className="overflow-h">
      <ProgressiveImage
        src={props.img.url}
        placeholder={props.img.thumbnails.small.url}
      >
        {(src, loading) => (
          <img
            className="module__image lazyloaded ga-uni-img"
            src={src}
            alt={`${props.alt} campus`}
            style={{opacity: loading ? 0.5 : 1 }}
            width="645"
          />
        )}
      </ProgressiveImage>
    </div>
  );
};

export default HeroImage;

HeroImage.propTypes = {
  img: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired
};
